import React, { Component } from 'react';
import Input from './input';

export default class Password extends Component {
  constructor(props) {
    super(props);
    const { cStyle } = props;
    let config = null;
    if (cStyle) {
      try {
        config = JSON.parse(cStyle);
      } catch (e) {
        config = {};
      }
    }
    config = Object.assign({ type: 'password' }, config);
    this.state = {
      cStyle: JSON.stringify(config)
    };
  }
  render() {
    return <Input {...this.props} cStyle={this.state.cStyle} />
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/password.jsx